module.exports = __webpack_public_path__ + "img/lily white_sc1.4f3aa829.png";